module.exports = __webpack_public_path__ + "files/3323cb09bb4df6da265d6be7ee704b2f.png";